export default {"src":"/_next/static/media/8-cnt-logo.d4e28e01.svg","height":24,"width":63};